// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Re17k","inner":"styles_inner__1sdYy","right":"styles_right__2uVXu","close":"styles_close__3qDul","footer":"styles_footer__3A7vC"};